module.exports = __webpack_public_path__ + "img/erro.e9282ef6.png";